<form [formGroup]="examOrderingProcessForm">
  <cpds-radio-card-group
    [theme]="'mm-light'"
    [options]="options"
    [allDisabled]="false"
    [allErrors]="false"
    groupName="examOptOut"
    [vertical]="false"
    [displayName]="'Exam ordering process'"
    formControlName="examOptOut"
  ></cpds-radio-card-group>
</form>
